import { useIdentityStore } from './store';

export const getCurrentUser = () => useIdentityStore.getState().user;
export const getCurrentCompany = () => useIdentityStore.getState().company;
